import { useQuery } from '@tanstack/react-query';
import { getCollectionFeedApi } from '../helpers/api/collectionsApi';

const KEYS = {
  GET_COLLECTION: 'GET_COLLECTION',
};

export function useGetCollection(id: string) {
  return useQuery([KEYS.GET_COLLECTION, id], () => getCollectionFeedApi(id), {
    enabled: !!id,
    retry: false,
  });
}
